import { layouts, common } from '@ocean/ui'
import { CardLayout, CardSegment, CardDetailsLayout } from 'layouts/cards'
import { CardLabel, CardPreview } from 'components/cards/common'
import { UICardType } from 'components/cards/common/types'

const { BaseGridLayout } = layouts
const { ContentTrace, Translucent } = common.skeletonStyles

type CardSkeletonProps = {
  variant?: 'activity' | 'group'
}

const Card: React.FC<CardSkeletonProps> = ({ variant }) => (
  <CardLayout variant={variant === 'group' ? UICardType.Group : UICardType.Activity}>
    <CardSegment segmentId='preview'>
      <CardPreview />
    </CardSegment>
    <CardSegment segmentId='title'>
      <ContentTrace width='90%' color='greyLight' />
      <br />
      <ContentTrace width='65%' color='greyLight' />
    </CardSegment>
    <CardSegment segmentId='label'>
      <CardLabel title='' />
    </CardSegment>
    <CardSegment segmentId='info'>
      <CardDetailsLayout>
        <ContentTrace width='20px' color='greyLight' />
        <ContentTrace width='170px' color='greyLight' />
      </CardDetailsLayout>
    </CardSegment>
    <CardSegment segmentId='status'>
      <ContentTrace width='100px' color='greyLight' />
    </CardSegment>
    <CardSegment segmentId='progress'>
      <ContentTrace width='100%' color='greyLight' />
    </CardSegment>
  </CardLayout>
)

const CardSkeleton: React.FC<CardSkeletonProps> = ({ variant }) => (
  <Translucent opacity='0.5' data-test='CardSkeleton'>
    <BaseGridLayout>
      <Card variant={variant} />
      <Card variant={variant} />
      <Card variant={variant} />
    </BaseGridLayout>
  </Translucent>
)

export default CardSkeleton
